import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CoreCommonModule } from '@core/common.module';
import { TranslocoModule } from '@jsverse/transloco';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { IPlaybooksItemDTO } from '../../../dto/playbooks-listening.dto';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';

@Component({
  selector: 'app-playbook-last-edited',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    CoreCommonModule,
    TranslocoModule,
    NgbModule,
    MomentPipe,
    UserTimeZoneFormatPipe
  ],
  templateUrl: './playbook-last-edited.component.html',
  styleUrl: './playbook-last-edited.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PlaybookLastEditedComponent {
    @Input() dataItem: IPlaybooksItemDTO;
    @Input() columnOptions: ITableColumn;

}
